export const getContactPaymentUrl = (funnelId: number, funnelStepId: number) =>
  `/funnels/${funnelId}#${funnelStepId}`
